import PropTypes from "prop-types";
import { CircleExclamationRegularV6 } from "../../../shared/v2/Icomoon";

const OptedOutBanner = ({ className }) => (
  <div
    className={`tw-py-[12px] tw-px-[16px] tw-rounded-[8px] tw-text-semantic-yellow-120 tw-bg-semantic-yellow-5 tw-flex tw-space-x-[16px] tw-items-center ${className}`}
  >
    <CircleExclamationRegularV6 size="xl" className="tw-text-semantic-yellow-110" />
    <div className="tw-space-y-[4px]">
      <p className="tw-font-bold tw-m-0 tw-text-12d">Some contacts have opted out of phone communication</p>
      <p className="tw-m-0 tw-text-12d tw-space-x-[4px]">
        Unless you have obtained permission, we recommend not calling contacts that have opted out.
      </p>
    </div>
  </div>
);

OptedOutBanner.propTypes = {
  className: PropTypes.string,
};

OptedOutBanner.defaultProps = {
  className: "",
};

export default OptedOutBanner;
